import { axiosInstance } from "@/plugins/axios";
import { ProductSpecificRule } from "@/modules/product_specific_rule/types";

export interface ProductSpecificRulePayload {
  offset: null,
  limit: null,
  agreement_group: null,
  id_agreement: null,
  search: null,
  start_application_date: null,
  end_application_date: null,
  type: null
}

export interface IndividualProductSpecificRulePayload {
  id: number,
  start_application_date: null,
  end_application_date: null
}

export interface ProductSpecificRuleByIds {
  ids: number[],
  start_application_date: null,
  end_application_date: null
}

export interface ProductSpecificRuleRawFilter {
    codes: [
        {
            code: string,
            agreement_name: string
        }
    ]
}

export async function getProductSpecificRules(payload: ProductSpecificRulePayload) {
    let url = 'product_specific_rules?';

    if (payload.limit) {
      url += `limit=${payload.limit}&offset=${payload.offset}&`;
    }

    if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
      url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`
    }

    if (payload.agreement_group) {
      url += `agreement_group=${payload.agreement_group}&`;
    }

    if (payload.search){
      url += `search=${payload.search}&`;
    }

    if (payload.type){
        url += `type=${payload.type}&`;
    }

    if (payload.id_agreement){
        url += `id_agreement=${payload.id_agreement}&`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
}

export async function getProductSpecificRule(payload: IndividualProductSpecificRulePayload) {
  let url = `product_specific_rules/${payload.id}?`;

  if (payload && payload.start_application_date) {
    url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getProductSpecificRuleByIds(payload: ProductSpecificRuleByIds) {
  const psrIds = payload.ids.join(',');
  let url = `product_specific_rules/get_by_ids?ids=${psrIds}`;

  if (payload && payload.start_application_date) {
    url += `&start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}`;
  }
  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getRawProductSpecificRuleByIds(payload: ProductSpecificRuleRawFilter) {
    const response = await axiosInstance.post(`product_specific_rules/raw`, {
        codes: payload.codes
    });
    return response.data;
}

export async function saveProductSpecificRule(product_specific_rule: ProductSpecificRule) {
  await axiosInstance.post(`product_specific_rules`, product_specific_rule);
}

export async function saveProductSpecificRules(product_specific_rules: ProductSpecificRule[]) {
  await axiosInstance.post(`product_specific_rules/create_or_update_many`, {
    product_specific_rules: product_specific_rules
  });
}

export async function deleteProductSpecificRule(id: string){
  await axiosInstance.delete(`product_specific_rules/${id}`)
}
